import React, { memo } from 'react'

const NoSearchResult = ({ title = '' }) => {
  return (
    <div className="no_search_result_container">
      <span className="no_search_result">{title}</span>
    </div>
  )
}

export default memo(NoSearchResult)
